export enum ClientViewTimeZone {
  EST = 'EST',
  CST = 'CST',
  MST = 'MST',
  PST = 'PST',
  AKST = 'AKST',
  HST = 'HST',
}

const StateToTimeZoneMap: Record<ClientViewTimeZone, string[]> = {
  [ClientViewTimeZone.EST]: [
    'FL', 'GA', 'SC', 'NC', 'KY', 'VA', 'WV', 'DC', 'MD', 'DE',
    'NJ', 'PA', 'OH', 'IN', 'MI', 'NY', 'CT', 'RI', 'MA', 'NH', 'VT', 'ME',
  ],
  [ClientViewTimeZone.CST]: [
    'TX', 'OK', 'LA', 'AR', 'MS', 'AL', 'TN', 'MO', 'KS', 'IL', 'IA', 'NE', 'WI', 'MN', 'SD', 'ND',
  ],
  [ClientViewTimeZone.MST]: ['AZ', 'NM', 'CO', 'UT', 'WY', 'ID', 'MT'],
  [ClientViewTimeZone.PST]: ['CA', 'NV', 'OR', 'WA'],
  [ClientViewTimeZone.AKST]: ['AK'],
  [ClientViewTimeZone.HST]: ['HI'],
}

const TimeZoneToZoneIdMap: Record<ClientViewTimeZone, string> = {
  [ClientViewTimeZone.EST]: 'America/New_York',
  [ClientViewTimeZone.CST]: 'America/Chicago',
  [ClientViewTimeZone.MST]: 'America/Denver',
  [ClientViewTimeZone.PST]: 'America/Los_Angeles',
  [ClientViewTimeZone.AKST]: 'America/Anchorage',
  [ClientViewTimeZone.HST]: 'Pacific/Honolulu',
}

function getByState(state: string): ClientViewTimeZone | null {
  const upperState = state.toUpperCase()
  for (const [zone, states] of Object.entries(StateToTimeZoneMap)) {
    if (states.includes(upperState)) {
      return zone as ClientViewTimeZone
    }
  }
  return null
}

export function getZoneIdByState(state: string): string | null {
  const zone = getByState(state)
  return zone ? TimeZoneToZoneIdMap[zone] : null
}
